module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/knife-1-e555f39651fbdc504db5d3dec4f515f5.svg";